import React, { useState } from "react";

import MerchantOnboardingList from "./components/MerchantOnboardingList";
import MerchantDetail from "./components/MerchantDetail";

const MerchantOnboarding: React.FC = () => {
	const [merchant, setMerchant] = useState();

	if (merchant) {
		return <MerchantDetail {...{ merchant, setMerchant }} />;
	}

	return (
		<div className="space-y-2">
			<MerchantOnboardingList setMerchant={setMerchant} />
		</div>
	);
};

export default MerchantOnboarding;
